import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ltc-rep" }
const _hoisted_2 = { class: "ltc-rep__head" }
const _hoisted_3 = { class: "ltc-rep__guide" }
const _hoisted_4 = { class: "ltc-rep__picked" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "ltc-rep__scroll" }
const _hoisted_8 = { class: "ltc-rep__stage" }
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = { class: "ltc-rep__el-text" }
const _hoisted_11 = { class: "ltc-rep__table" }
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = {
  key: 1,
  class: "ltc-rep__val"
}
const _hoisted_15 = { class: "ltc-rep__table" }
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "ltc-rep__box is-unknown"
}
const _hoisted_20 = {
  key: 1,
  class: "ltc-rep__val"
}

import { computed, ref } from 'vue'

type Summary = {
  name?: string
  certNo?: string
  qualification?: string
  validTerm?: string
  contractTerm?: string
}

type Grid = {
  headers: string[]
  rows: string[][]
}

type Control = {
  id: string
  text: string
  label: string
  left: number
  top: number
  width: number
  height: number
  kind: 'label' | 'value' | 'input' | 'button' | 'search' | 'note' | 'section' | 'point'
}

const TITLE = 28
const MAIN = 85

type ScheduleCol = {
  col: number
  label: string
  width: number
  check?: boolean
  week: string
  id: string
  day?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsPaymtModalReplica',
  props: {
    yearMonth: {},
    summary: {},
    grid: {}
  },
  setup(__props: any) {

const props = __props

const form = (id: string, text: string, label: string, left: number, top: number, width: number, height: number, kind: Control['kind']): Control => ({
  id, text, label, left, top: top + TITLE, width, height, kind,
})

const main = (id: string, text: string, label: string, left: number, top: number, width: number, height: number, kind: Control['kind']): Control => (
  form(id, text, label, left, top + MAIN, width, height, kind)
)

const controls: Control[] = [
  form('sta_saveMsg', '※ 중복 점검은 저장 및 통보시 수행됩니다.', '저장 안내', 737, 6, 267, 18, 'note'),
  form('sta_title', '(방문요양)', '급여종류', 867, 6, 194, 17, 'value'),
  form('btn_save', '저장 및 통보', '저장 및 통보', 1064, 4, 114, 22, 'button'),
  form('btn_close', '닫기', '닫기', 1182, 4, 68, 22, 'button'),
  form('Static10', '년월', '년월', 15, 42, 48, 16, 'label'),
  form('cmb_ctrYm', '', '년월 입력', 68, 39, 124, 22, 'input'),
  form('Static08', '대상자', '대상자', 212, 42, 72, 16, 'label'),
  form('cmb_obj', '', '대상자 입력', 282, 39, 350, 22, 'input'),
  form('btn_select', '조회', '조회', 637, 39, 75, 22, 'search'),
  main('Static18', '장기요양대상자', '장기요양대상자', 0, 3, 205, 26, 'section'),
  main('btn_cncl', '계약통보서 해지', '계약통보서 해지', 1015, 4, 107, 25, 'button'),
  main('btn_reCal', '월금액 재산정', '월금액 재산정', 1126, 4, 124, 25, 'button'),
  main('stc_13', '성명', '성명', 0, 32, 88, 32, 'label'),
  main('sta_fnm', '박은주', '성명', 96, 32, 69, 32, 'value'),
  main('stc_04', '장기요양인정번호', '장기요양인정번호', 174, 32, 135, 32, 'label'),
  main('sta_ltcMgmtNo', 'L2307138185', '장기요양인정번호', 316, 32, 92, 32, 'value'),
  main('stc_00', '자격', '자격', 416, 32, 51, 32, 'label'),
  main('sta_qlfType', '일반', '자격', 475, 32, 75, 32, 'value'),
  main('stc_15', '인정유효기간', '인정유효기간', 562, 32, 120, 32, 'label'),
  main('sta_rcgtValidTerm', '2025-08-17 ~ 2029-08-16', '인정유효기간', 687, 32, 182, 32, 'value'),
  main('stc_24', '계약기간', '계약기간', 880, 32, 120, 32, 'label'),
  main('sta_ctrTerm', '2026-09-01 00:00 ~ 2029-08-16 24:00', '계약기간', 1008, 32, 238, 32, 'value'),
  main('Static04', '급여일정등록·변경', '급여일정등록·변경', 0, 68, 179, 28, 'section'),
  main('sta_cnclMsg01', '※ 급여일정 종료시간이 익일인 경우는 노란색으로 표시됩니다.', '일정 안내', 148, 73, 371, 22, 'note'),
  main('stc_point', '', '로딩 표시', 668, 69, 51, 30, 'point'),
  main('btn_addRow', '입력', '입력', 671, 72, 45, 25, 'button'),
  main('btn_upd', '지난일정 수정', '지난일정 수정', 720, 72, 115, 25, 'button'),
  main('btn_upHist', '지난일정 수정이력', '지난일정 수정이력', 839, 72, 138, 25, 'button'),
  main('btn_print', '인쇄', '인쇄', 981, 72, 50, 25, 'button'),
  main('btn_printCal', '인쇄(달력)', '인쇄(달력)', 1035, 72, 87, 25, 'button'),
  main('btn_addPaymtOffrDesc', '지급 이후 통보', '지급 이후 통보', 1126, 72, 124, 25, 'button'),
  main('Static14', '계약통보서 해지', '계약통보서 해지', 0, 343, 287, 28, 'section'),
  main('sta_cnclMsg02', '※ 월 한도액 추가 산정 기준으로 급여일정을 등록하여도, 실제 서비스를 제공하지 않으면 추가 산정되지 않습니다.', '해지 안내', 124, 348, 900, 22, 'note'),
]

const WEEK = ['일', '월', '화', '수', '목', '금', '토']

const yearMonthLabel = computed(() => {
  const matched = /^(\d{4})-(\d{2})$/.exec(props.yearMonth || '2026-08')
  if (!matched) return '2026년 8월'
  return `${matched[1]}년 ${Number(matched[2])}월`
})

const days = computed(() => {
  const matched = /^(\d{4})-(\d{2})$/.exec(props.yearMonth || '2026-08')
  const year = matched ? Number(matched[1]) : 2026
  const month = matched ? Number(matched[2]) : 8
  const last = new Date(year, month, 0).getDate()
  return Array.from({ length: last }, (_, index) => ({
    day: index + 1,
    week: WEEK[new Date(year, month - 1, index + 1).getDay()],
    col: 14 + index,
  }))
})

const fixedCols: { col: number; label: string; width: number; check?: boolean }[] = [
  { col: 0, label: '삭제', width: 36 },
  { col: 1, label: '요양요원', width: 72 },
  { col: 3, label: '가족 여부', width: 44 },
  { col: 7, label: '시작 시간', width: 44 },
  { col: 8, label: '종료 시간', width: 44 },
  { col: 9, label: '제공 시간', width: 44 },
  { col: 10, label: '횟수', width: 36 },
  { col: 13, label: '전체 선택', width: 44, check: true },
]

const scheduleCols = computed<ScheduleCol[]>(() => [
  ...fixedCols.map((col) => ({
    ...col,
    id: `grd_paymtDypr.head.cell_-1_${col.col}`,
    week: '',
  })),
  ...days.value.map((day) => ({
    col: day.col,
    label: `${day.day}\n(${day.week})`,
    width: 30,
    check: true,
    week: day.week,
    day: day.day,
    id: `grd_paymtDypr.head.cell_-1_${day.col}`,
  })),
])

const limitItems = [
  { label: '이용횟수', value: '0' },
  { label: '인지활동형 횟수', value: '0' },
  { label: '월금액', value: '0 원' },
  { label: '타급여포함 월금액', value: '0 원' },
  { label: '월 한도액', value: '0 원' },
  { label: '월한도 초과금액', value: '0 원' },
  { label: '승인금액', value: '0 원' },
  { label: '월한도 미포함금액', value: '0 원' },
]

const cancelBands = [
  {
    id: 'grd_paymtCnclctr.등급',
    label: '등급',
    check: false,
    value: (day: number) => (day <= 16 ? '3' : '없음'),
    cellId: (day: number) => `grd_paymtCnclctr.body.cell_0_${day}`,
  },
  {
    id: 'grd_paymtCnclctr.자격',
    label: '자격',
    check: false,
    value: (day: number) => (day <= 16 ? '일반' : '없음'),
    cellId: (day: number) => `grd_paymtCnclctr.body.cell_0_${32 + day}`,
  },
  {
    id: 'grd_paymtCnclctr.해지여부',
    label: '해지여부',
    check: true,
    value: () => '',
    cellId: (day: number) => `grd_paymtCnclctr.body.cell_0_${64 + day}`,
  },
  {
    id: 'grd_paymtCnclctr.해지시간',
    label: '해지시간',
    check: false,
    value: () => '없음',
    cellId: (day: number) => `grd_paymtCnclctr.body.cell_0_${96 + day}`,
  },
]

const gridBox = { left: '0px', top: `${TITLE + MAIN + 103}px`, width: '1250px', height: '179px' }
const limitBox = { left: '0px', top: `${TITLE + MAIN + 295}px`, width: '1250px', height: '40px' }
const cancelBox = { left: '0px', top: `${TITLE + MAIN + 377}px`, width: '1250px', height: '150px' }

const picked = ref<{ id: string; label: string } | null>(null)
const copied = ref(false)

const box = (el: Control) => ({
  left: `${el.left}px`,
  top: `${el.top}px`,
  width: `${el.width}px`,
  height: `${el.height}px`,
})

const dayClass = (week: string) => {
  if (week === '일') return 'is-sun'
  if (week === '토') return 'is-sat'
  return ''
}

const bodyId = (row: number, col: number) => `grd_paymtDypr.body.cell_${row}_${col}`
const cancelHeadId = (day: number) => `grd_paymtCnclctr.head.cell_-1_${day}`

const controlText = (el: Control) => {
  if (el.id === 'cmb_ctrYm') return yearMonthLabel.value
  const summary = props.summary
  if (!summary) return el.text
  if (el.id === 'sta_fnm' && summary.name) return summary.name
  if (el.id === 'sta_ltcMgmtNo' && summary.certNo) return summary.certNo
  if (el.id === 'sta_qlfType' && summary.qualification) return summary.qualification
  if (el.id === 'sta_rcgtValidTerm' && summary.validTerm) return summary.validTerm
  if (el.id === 'sta_ctrTerm' && summary.contractTerm) return summary.contractTerm
  return el.text
}

const scheduleRowCount = computed(() => {
  const count = props.grid?.rows?.length || 0
  return count > 0 ? count : 4
})

const headerIndex = (col: ScheduleCol) => {
  const headers = props.grid?.headers || []
  if (col.day) {
    return headers.findIndex((header) => {
      const flat = String(header || '').replace(/\s+/g, ' ').trim()
      return new RegExp(`^${col.day}(?:\\s|\\(|$)`).test(flat)
    })
  }
  const key = col.label.replace(/\s/g, '')
  return headers.findIndex((header) => String(header || '').replace(/\s/g, '') === key)
}

const rawCell = (row: number, col: ScheduleCol) => {
  const line = props.grid?.rows?.[row]
  if (!line) return null
  const index = headerIndex(col)
  if (index < 0) return null
  return line[index] ?? ''
}

const checkState = (row: number, col: ScheduleCol) => {
  const raw = rawCell(row, col)
  if (raw == null) return 'unknown'
  const text = String(raw).replace(/\s/g, '')
  if (text === '✓' || text === '1' || text === 'Y' || text === 'y') return 'on'
  if (text === '' || text === '0') return 'off'
  return 'unknown'
}

const cellText = (row: number, col: ScheduleCol) => {
  const raw = rawCell(row, col)
  if (raw == null) return '없음'
  const text = String(raw).replace(/\s+/g, ' ').trim()
  return text || '없음'
}

const cellTitle = (row: number, col: ScheduleCol) => {
  const id = bodyId(row, col.col)
  if (!col.check) return `${id} ${cellText(row, col)}`
  const state = checkState(row, col)
  const label = state === 'on' ? '체크 있음' : state === 'off' ? '체크 없음' : '체크 미확인'
  return `${id} ${label}`
}

const choose = async (id: string, label: string) => {
  picked.value = { id, label }
  copied.value = false
  try {
    await navigator.clipboard.writeText(id)
    copied.value = true
  } catch {
    copied.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "ltc-rep__title" }, "급여계약내용 등록 모달", -1)),
      _createElementVNode("p", _hoisted_3, "년월은 요청한 " + _toDisplayString(yearMonthLabel.value) + "입니다. 체크는 있음·없음·미확인으로 나누고, 글자 칸은 값이 없으면 없음이라고 적습니다. 요소를 누르면 id가 위에 남습니다.", 1)
    ]),
    _createElementVNode("p", _hoisted_4, [
      (picked.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[3] || (_cache[3] = _createTextVNode(" 선택한 요소 ", -1)),
            _createElementVNode("strong", null, _toDisplayString(picked.value.id), 1),
            (picked.value.label)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · " + _toDisplayString(picked.value.label), 1))
              : _createCommentVNode("", true),
            (copied.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · 복사됨"))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("아직 고른 요소가 없습니다.")
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "ltc-rep__winbar" }, "급여계약내용 등록(재가)[npia107p01]", -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(controls, (el) => {
          return _createElementVNode("button", {
            key: el.id + el.top + el.left,
            type: "button",
            class: _normalizeClass(["ltc-rep__el", ['is-' + el.kind, { 'is-on': picked.value?.id === el.id }]]),
            style: _normalizeStyle(box(el)),
            title: el.id,
            onClick: ($event: any) => (choose(el.id, el.label || el.text || ''))
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(controlText(el)), 1)
          ], 14, _hoisted_9)
        }), 64)),
        _createElementVNode("div", {
          class: "ltc-rep__grid",
          style: gridBox,
          title: "grd_paymtDypr"
        }, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleCols.value, (col) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: col.id,
                    class: _normalizeClass(dayClass(col.week)),
                    style: _normalizeStyle({ width: col.width + 'px' }),
                    title: col.id,
                    onClick: ($event: any) => (choose(col.id, col.label))
                  }, _toDisplayString(col.label), 15, _hoisted_12))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleRowCount.value, (row) => {
                return (_openBlock(), _createElementBlock("tr", { key: row }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleCols.value, (col) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: col.id + row,
                      title: cellTitle(row - 1, col),
                      onClick: ($event: any) => (choose(bodyId(row - 1, col.col), col.label))
                    }, [
                      (col.check)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["ltc-rep__box", 'is-' + checkState(row - 1, col)])
                          }, null, 2))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(cellText(row - 1, col)), 1))
                    ], 8, _hoisted_13))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "ltc-rep__limit",
          style: limitBox,
          title: "grd_limit",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (choose('grd_limit', '월 한도')))
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(limitItems, (item) => {
            return _createElementVNode("span", {
              key: item.label
            }, _toDisplayString(item.label) + " " + _toDisplayString(item.value), 1)
          }), 64))
        ]),
        _createElementVNode("div", {
          class: "ltc-rep__grid is-cancel",
          style: cancelBox,
          title: "grd_paymtCnclctr"
        }, [
          _createElementVNode("table", _hoisted_15, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "is-name",
                  title: "grd_paymtCnclctr 일자",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (choose('grd_paymtCnclctr', '일자')))
                }, "일자"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: 'c' + day.day,
                    class: _normalizeClass(dayClass(day.week)),
                    title: cancelHeadId(day.day),
                    onClick: ($event: any) => (choose(cancelHeadId(day.day), day.day + '일'))
                  }, [
                    _createTextVNode(_toDisplayString(day.day), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode("(" + _toDisplayString(day.week) + ")", 1)
                  ], 10, _hoisted_16))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cancelBands, (band) => {
                return _createElementVNode("tr", {
                  key: band.id
                }, [
                  _createElementVNode("td", {
                    class: "is-name",
                    title: band.id,
                    onClick: ($event: any) => (choose(band.id, band.label))
                  }, _toDisplayString(band.label), 9, _hoisted_17),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: band.id + day.day,
                      title: band.cellId(day.day),
                      onClick: ($event: any) => (choose(band.cellId(day.day), band.label + ' ' + day.day + '일'))
                    }, [
                      (band.check)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                        : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(band.value(day.day) || '없음'), 1))
                    ], 8, _hoisted_18))
                  }), 128))
                ])
              }), 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})